import { Component, OnInit, inject, input, signal } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { NavItem, SIDEBAR_CONSTANTS } from '@shared';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { NgTemplateOutlet } from '@angular/common';
@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.scss'],
    // eslint-disable-next-line @angular-eslint/no-host-metadata-property
    host: { class: 'app-sidebar' },
    imports: [AngularSvgIconModule, RouterLink, NgTemplateOutlet]
})
export class SidebarComponent implements OnInit {
  private router = inject(Router);
  private route = inject(ActivatedRoute);

  items: NavItem[] = SIDEBAR_CONSTANTS;
  readonly NavItems = input<NavItem[]>([]);
  readonly activeItem = input<NavItem | null>(null);
  readonly activeId = input<string | number>('0');
  activeIds = signal<(string | number)[]>([]);

  constructor() {
    const NavItems = this.NavItems();
    if (NavItems.length) this.items = NavItems; // Override Items if input found.
  }

  ngOnInit(): void {
    const activeId = this.activeId();
    if (activeId) {
      this.active(activeId);
    }
  }

  active(id: any) {
    this.activeIds.set([id]);
    const parentsOfItem = this.findParentItems(this.items, id)?.map((item) => item.id);
    if (parentsOfItem) {
      this.activeIds.set([...parentsOfItem, id]);
    }
  }

  isActive(id: string | number) {
    return this.activeIds().includes(id);
  }

  findParentItems(navItems: NavItem[], itemId: string, parents: NavItem[] = []): NavItem[] | null {
    for (const item of navItems) {
      if (item.id === itemId) {
        // If the item with the given ID is found, return its parents
        return parents;
      }
      if (item.children) {
        const foundInChildren = this.findParentItems(item.children, itemId, [...parents, item]);
        if (foundInChildren) {
          return foundInChildren;
        }
      }
    }
    return null; // Return null if the item is not found
  }
}
